import { render } from "./IsoCresh.vue?vue&type=template&id=8db78642&scoped=true"
import script from "./IsoCresh.vue?vue&type=script&lang=js"
export * from "./IsoCresh.vue?vue&type=script&lang=js"

import "./IsoCresh.vue?vue&type=style&index=0&id=8db78642&lang=css"
import "./IsoCresh.vue?vue&type=style&index=1&id=8db78642&scoped=true&lang=css"
import "./IsoCresh.vue?vue&type=style&index=2&id=8db78642&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db78642"]])

export default __exports__